import { createStyles, Drawer, List, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "..";
import { AppMenuProps, AppMenuPropsExtended } from "./appMenuProps";
import { Logo } from "./logo";

export const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            wrapper: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
            },
            drawer: {
                color: theme.palette.common.black,
                width: theme.relode.sizes.drawerWidth,
                transition: theme.transitions.create(["width"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            drawerPaper: {
                backgroundColor: theme.relode.colors.appMenuBackground.main,
                width: theme.relode.sizes.drawerWidth,
                overflowX: "hidden",
                transition: theme.transitions.create(["width"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                borderRight: "none",
            },
            drawerClosed: {
                width: theme.relode.sizes.drawerWidthClosed,
                transition: theme.transitions.create(["width"], {
                    easing: theme.transitions.easing.easeIn,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            contextArea: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 0,
                padding: 8,
                alignItems: "center",
            },
            menuArea: {
                flexGrow: 1,
            },
            systemArea: {
                flexGrow: 0,
                padding: "8px 0",
            },
        }),
    { name: "AppMenu" }
);

type AppMenuClassNames =
    | "root"
    | "wrapper"
    | "drawer"
    | "drawerPaper"
    | "drawerClosed"
    | "contextArea"
    | "menuArea"
    | "systemArea";
export type AppMenuClasses = Record<AppMenuClassNames, string>;

const getClassNames = (
    props: AppMenuProps & { isMenuOpen: boolean },
    classes: AppMenuClasses
) => {
    const { isMenuOpen } = props;

    const drawer = classnames({
        [classes.drawer]: true,
        [classes.drawerClosed]: !isMenuOpen,
    });

    const drawerPaper = classnames({
        [classes.drawerPaper]: true,
        [classes.drawerClosed]: !isMenuOpen,
    });

    const wrapper = classnames({
        [classes.wrapper]: true,
    });

    const contextArea = classnames({
        [classes.contextArea]: true,
    });

    const menuArea = classnames({
        [classes.menuArea]: true,
    });

    const systemArea = classnames({
        [classes.systemArea]: true,
    });

    return {
        contextArea,
        drawer,
        drawerPaper,
        menuArea,
        systemArea,
        wrapper,
    };
};

export const AppMenuDesktop = (
    props: AppMenuProps &
        AppMenuPropsExtended & { isMenuOpen: boolean; toggleMenu: () => void }
) => {
    const classes = useStyles(props);
    const {
        isMenuOpen,
        toggleMenu,
        contextArea,
        menuItems,
        systemItems,
    } = props;

    const classNames = getClassNames(
        { ...props, isMenuOpen: isMenuOpen },
        classes
    );
    return (
        <>
            <Drawer
                open={isMenuOpen}
                variant="permanent"
                className={classNames.drawer}
                classes={{
                    paper: classNames.drawerPaper,
                }}
            >
                <div className={classNames.wrapper}>
                    <Logo
                        data-cy="relode-logo"
                        isOpen={isMenuOpen}
                        onClick={toggleMenu}
                    />
                    {contextArea && (
                        <div className={classNames.contextArea}>
                            {contextArea}
                        </div>
                    )}
                    <div className={classNames.menuArea}>
                        <List component="nav">{menuItems}</List>
                    </div>
                    <div className={classNames.systemArea}>
                        <List component="nav">{systemItems}</List>
                    </div>
                </div>
            </Drawer>
        </>
    );
};
